import { render, staticRenderFns } from "./lookupviewwallet.vue?vue&type=template&id=4f483a4f&"
import script from "./lookupviewwallet.vue?vue&type=script&lang=js&"
export * from "./lookupviewwallet.vue?vue&type=script&lang=js&"
import style0 from "./lookupviewwallet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports